export default class ProductModel {
  constructor( data ) {
    this._type = "ProductModel"
    Object.assign( this, addImageLinks( data ) )

    this.desc = this.desc || {}
    this.description = this.desc.des
    this.excerpt = ""
    this.title = this.desc.short_des

    this.extras = data.extras || {}
    this.cats = data.cats || [{}]
    // Pre-Select the first quantity
    try {
      this.quantities = this.quantities || [{ map_desc_id: "NA", multi: 0 }]
      this.unit_id = this.quantities[ 0 ].map_desc_id
      this.unit_multi = this.quantities[ 0 ].multi
      this._count = 0
    } catch ( err ) {
      console.warn( err, this )
    }
  }

  calculate( count = this.count ) {
    this._sum = this.price * this.unit_multi * count
    return this._sum
  }

  getNotice() {
    return "Create an availability indicator in your ProductModel.getNotice() output"
  }

  setPrice( price ) {
    this.price = price
  }

  setCount( count ) {
    this._count = count
    this.findBulkPrice()
  }

  get count() {
    return this._count
  }

  set count( value ) {
    this.setCount( value )
  }

  findBulkPrice() {

    // no bulk price
    if ( !this.prices ) {
      this.setPrice( this.price )
      return this.price
    }
    let count = this.count || 1
    let price = Infinity
    let n = count * this.unit_multi

    this.prices.forEach( bulkPrice => {
      if ( n >= bulkPrice.q ) {
        price = Math.min( price, bulkPrice.p )
      }
    } )

    // if no bulk price found => use the base price
    if ( price === Infinity ) {
      price = this.base_price
    }
    this.setPrice( price )
    return price
  }

}

export const productModelFactory = function ( Model ) {
  if ( !Model ) {
    return ProductModel
  }
  return class Model extends ProductModel {
  }
}

function ImageSet( id, key, description = "_" ) {
  let config = window.__bshop_config
  var data = {}
  data.img_src = config.MEDIA + description + "/" + id + "/" + key + "?size=small"
  data.img_src_small = config.MEDIA + description + "/" + id + "/" + key + "?size=small"
  data.img_src_medium = config.MEDIA + description + "/" + id + "/" + key + "?size=medium"
  data.img_src_large = config.MEDIA + description + "/" + id + "/" + key + "?size=large"
  return data
}

export const addImageLinks = function ( data = {} ) {
  let config = window.__bshop_config // this will break.
  if ( data && data.images && data.images.length > 0 ) {
    // prepare img source
    data.img_src = config.MEDIA + "description/" + data.map_pic_id + "/1?size=small"
    data.img_src_small = config.MEDIA + "description/" + data.map_pic_id + "/1?size=small"
    data.img_src_medium = config.MEDIA + "description/" + data.map_pic_id + "/1?size=medium"
    data.img_src_large = config.MEDIA + "description/" + data.map_pic_id + "/1?size=large"
    data.img_srcs = []

    if ( Array.isArray( data.images ) ) {
      data.images.forEach( ( imgKey ) => {
        data.img_srcs.push( new ImageSet( data.map_pic_id, imgKey ) )
      } )
    }


  } else {
    data.img_src = "/image/placeholder.png"
    data.img_src_small = "/image/placeholder.png"
    data.img_src_medium = "/image/placeholder.png"
    data.img_src_large = "/image/placeholder.png"
    data.img_srcs = []

    var imgSet = {}
    imgSet.img_src = "/image/placeholder.png"
    imgSet.img_src_small = "/image/placeholder.png"
    imgSet.img_src_medium = "/image/placeholder.png"
    imgSet.img_src_large = "/image/placeholder.png"
    data.img_srcs.push( imgSet )
  }
  return data
}



// WEBPACK FOOTER //
// ./src/sdk/ProductModel.js